/*** IMPORTS FROM imports-loader ***/
import hydrator from "@gjensidige/views-api/src/runtime/hydrator";
import Component from ".";

/* global hydrator, Component */

// create a map of what we have hydrated, share it on window
window.__HYDRATED__ = window.__HYDRATED__ || {};

// get the current script executing
const partSrc = window.document?.currentScript?.getAttribute('src');

// filter the ones that need to be hydrated (data-nodeid contains the id for the props -> only hydration on node id's)
const parts = Array.from(
  document.querySelectorAll('script[src="' + partSrc + '"]')
).filter((part) => part.getAttribute('data-nodeid'));

// if this selection of parts contains elements that needs to be hydrated, add an eventListener
if (parts.length && window.addEventListener) {
  window.addEventListener('load', function () {
    parts.forEach((part) => {
      // make sure we only hydrate our components once
      const NODE_ID = part.getAttribute('data-nodeid');
      if (!window.__HYDRATED__[NODE_ID]) {
        window.__HYDRATED__[NODE_ID] = true;
        hydrator(Component, NODE_ID);
      }
    });
  });
}


import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types/prop-types';
import { Button, Title, Flex } from '@gjensidige/builders-components';
import { HeaderFeatureProps as Props } from './types';
import styles from '../less/header-feature.module.less';

const SIZES = `(min-width: 1024px) and (max-width: 1199px) 1024px, (min-width: 1200px) and (max-width: 1619px) 1200px, (min-width: 1620px) 2200px, 100vw`;

export const HeaderFeature = ({
  title,
  image,
  buttons,
  mobileImage
}: Props) => (
  <Flex
    align="end"
    as="header"
    className={classNames(styles.headerFeature, styles.marginBHeaders)}
  >
    {!!image && (
      <img
        alt={mobileImage?.alt || image.alt || ''}
        sizes={SIZES}
        src={mobileImage?.url || image.url}
        srcSet={mobileImage?.srcset || image.srcset}
      />
    )}
    {!!image && (
      <img
        alt={image.alt || ''}
        hidden
        sizes={SIZES}
        src={image.url}
        srcSet={image.srcset}
      />
    )}
    <Flex center layout={{ xs: 1, md: 7.5 }}>
      <Flex layout="1" gap={{ xs: 'xs', md: 'md' }}>
        {!!title && <Title as="h1" text={title} uppercase />}
        {!!buttons?.length && (
          <Flex gap={{ xs: 'xs sm', md: 'md' }}>
            {buttons.map(({ text, url }, index, { length }) => (
              <Button
                key={index}
                href={url}
                data-theme="dark"
                variant={
                  length === 1 ? 'critical' : index ? 'secondary' : 'primary'
                }
              >
                {text}
              </Button>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  </Flex>
);

HeaderFeature.CSR = true;
HeaderFeature.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.any.isRequired,
  mobileImage: PropTypes.any,
  buttons: PropTypes.array
};

export default HeaderFeature;
